<script setup lang="ts">

import GFBalanceLayout from '@/components/Sections/Government/Finances/Layouts/GFBalanceLayout.vue'
import GFBalanceSheetDetails from '@/components/Sections/Government/Finances/Layouts/GFBalanceSheetDetails.vue'

</script>

<template>

<div class="flex">
  <div class="w-full md:w-1/2 pt-2 pl-2">
    <GFBalanceLayout></GFBalanceLayout>
  </div>
  <div class="hidden md:block md:w-1/2 pt-2 pr-2">
    <GFBalanceSheetDetails></GFBalanceSheetDetails>
  </div>
</div>
</template>

<style scoped lang="scss">

</style>